import { styled as muiStyled, Box, Stack } from '@mui/material';

import { COLORS } from '../../../../../../themes/colors';
import styled from 'styled-components';

export const Wrapper = muiStyled(Box)(() => ({
  backgroundColor: `${COLORS.GRAY['-12']}`,
}));

export const Container = muiStyled(Stack)(() => ({}));

export const ContentWrapper = styled.div`
  width: 100%;
`;

export const CardsWrapper = styled.div`
  display: flex;
  gap: 16px;
`;
